import Model from '../../../../utils/Model'
import HTTPService from '../../HTTPService'
import BachataPayloadCast from './BachataPayloadCast'

class Bachata extends Model {
  get (companySlug, channelSlug) {
    return HTTPService.get(`company/${companySlug}/channel/${channelSlug}/transport/bachata`)
  }

  create (companySlug, channelSlug, payload) {
    payload = this.preparePayloadByCast(payload, BachataPayloadCast)
    return HTTPService.post(`company/${companySlug}/channel/${channelSlug}/transport/bachata`, payload)
  }

  update (companySlug, channelSlug, payload) {
    payload = this.preparePayloadByCast(payload, BachataPayloadCast)
    return HTTPService.put(`company/${companySlug}/channel/${channelSlug}/transport/bachata`, payload)
  }

  delete (companySlug, channelSlug) {
    return HTTPService.delete(`company/${companySlug}/channel/${channelSlug}/transport/bachata`)
  }
}

export default new Bachata()
